import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreatePhysicalDockActions as Actions,
  CreatePhysicalDockRequestAction as RequestAction,
} from 'store/ducks/physicalDocks';

export function* createPhysicalDockRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, 'docks-physical', postData);
    const shouldCommit = onSuccess?.();
    if (shouldCommit === false) return;
    notify('success', 'Doca física criada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    const shouldCommit = onFailure?.();
    if (shouldCommit === false) return;
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
